import { ProductTypes } from './product-types';

/**
 * Local Kerri Kelly laser-cut panel catalog (Feeney task 1d).
 *
 * Temporary stand-in until the real 'Laser Cut Kelly N' products are published
 * on the backend: merged into the product list so the 9 Kelly designs render
 * in 3D instead of showing a "product is missing" toast. A local entry is
 * skipped as soon as the backend has a product with the same productType.
 *
 * Models: assets/models/laser-cut/kelly_N.obj|.mtl (+ kelly_N.png alpha
 * texture). Same mesh contract as the existing laser panels: 'panel',
 * 'frameBottom', 'frameTop' (see ConstantsService.meshes). The perforation is
 * an alpha-tested texture on an oversized plane — the generation pipeline
 * clips it to the opening with material clipping planes, exactly like the
 * backend panels.
 */
export interface ILocalLaserPanelProduct {
  id: string;
  productType: string;
  railingType: string[];
  hasFrame: boolean;
  rotatePanel: boolean;
  height: number;
  width: number;
  modelObj: string;
  modelMtl: string;
  localAsset: boolean;
}

const MODEL_DIR = 'laser-cut/';

const KELLY_KEYS = [
  'laserCutKelly1',
  'laserCutKelly2',
  'laserCutKelly3',
  'laserCutKelly4',
  'laserCutKelly5',
  'laserCutKelly6',
  'laserCutKelly7',
  'laserCutKelly8',
  'laserCutKelly9'
];

export const LOCAL_KELLY_PANELS: ILocalLaserPanelProduct[] = KELLY_KEYS.map(
  (key, i) => ({
    id: `local_laser_kelly_${i + 1}`,
    productType: ProductTypes[key],
    railingType: ['DesignRail'],
    hasFrame: true,
    rotatePanel: true,
    // Oversized blank in cm; the material clipping planes cut it to size.
    height: 120,
    width: 260,
    modelObj: `${MODEL_DIR}kelly_${i + 1}.obj`,
    modelMtl: `${MODEL_DIR}kelly_${i + 1}.mtl`,
    localAsset: true
  })
);

export function mergeLocalKellyPanels(apiProducts: any[]): any[] {
  const apiTypes = new Set((apiProducts || []).map(p => p && p.productType));
  const extras = LOCAL_KELLY_PANELS.filter(p => !apiTypes.has(p.productType));
  return [...(apiProducts || []), ...extras];
}



// WEBPACK FOOTER //
// ./src/app/models/2d3d/laser-cut-kelly-local.config.ts